/**
 * SmsMetinSayaci — bir SMS metninin canlı sayacı (backlog #637; #643 duyuru yazma ekranı da kullanır).
 *
 * Satıcının saydığı gibi: karakter, SAYILAN karakter (bazıları iki sayılır), SMS parça sayısı ve — OTP metinleri için — 160 sınırı (satıcının eklediği kodla birlikte,
 * bu yüzden kendi metin yaklaşık 150'de kalmalı). Satıcının tablosunda karşılığı olmayan karakterler (çift tırnak, ters bölü, [ ] |, Latin olmayanlar) ayrıca
 * sayılır: backend bunları kaydederken ve gönderirken reddeder. `ornekler` verilirse yer tutucular örnek değerleriyle doldurulup ÖYLE ölçülür.
 */
import React from 'react';
import { Badge } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { OTP_ONERILEN, OTP_SINIRI, SMS_MAX, doldur, olc } from '../../../../services/smsMetin';

const SmsMetinSayaci = ({ metin, otp = false, ornekler }) => {
  const { t } = useTranslation('sms');
  const o = olc(ornekler ? doldur(metin, ornekler) : metin);
  const sinir = otp ? OTP_SINIRI : SMS_MAX;
  const asti = o.weighted > sinir;
  return (
    <div className="small d-flex flex-wrap gap-2 align-items-center mt-1" data-testid="sms-sayac">
      <span>{t('sayac.karakter', { sayi: o.length })}</span>
      <span className={asti ? 'text-danger fw-semibold' : undefined} data-testid="sms-sayac-sayilan">{t('sayac.sayilan', { sayi: o.weighted, sinir })}</span>
      <Badge color={o.parts > 1 && !otp ? 'warning' : 'light'} className="text-body">{t('sayac.parca', { sayi: o.parts })}</Badge>
      {o.ekstra > 0 && <span className="text-muted" data-testid="sms-sayac-cift">{t('sayac.ciftSayilan', { sayi: o.ekstra })}</span>}
      {o.turkce && <span className="text-muted">{t('sayac.turkce')}</span>}
      {otp && <span className="text-muted">{t('sayac.otpIpucu', { sinir: OTP_SINIRI, onerilen: OTP_ONERILEN })}</span>}
      {asti && <span className="text-danger" data-testid="sms-sayac-asti">{otp ? t('sayac.otpAsti', { sinir }) : t('sayac.asti', { sinir })}</span>}
      {o.desteklenmeyen.length > 0 && (
        <span className="text-danger" data-testid="sms-sayac-desteklenmeyen">{t('sayac.desteklenmeyen', { karakterler: o.desteklenmeyen.join(' ') })}</span>
      )}
    </div>
  );
};

export default SmsMetinSayaci;
